// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CFK8","footer":"styles_footer__2z0zF","passCodeTooltip":"styles_passCodeTooltip__-jaD8"};